import { Expose, Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class ReportActivityUserExpenseCountersDto {
  @Expose()
  @Transform(({ value }) => toEuros(value))
  totalCost: number;
}
